import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const mustChangePasswordGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (authService.mustChangePassword()) {
        return router.createUrlTree(['/change-password']);
    }

    return true;
};